<script setup lang="ts">
const route = useRoute();
const hasImage = computed(() => route.path.match(/(login|sign-up)/));

const theme = useTheming();
const authCoverURL = theme.authCoverURL;
</script>

<template>
  <div class="relative flex h-screen items-start">
    <AuthHeader>
      <div id="header-actions" />
    </AuthHeader>
    <div v-if="hasImage" class="hidden h-full w-2/5 shrink-0 lg:flex">
      <RImage :src="authCoverURL" class="w-full object-cover" />
    </div>
    <div class="size-full overflow-y-auto bg-white dark:bg-neutral-dark-900 dark:text-neutral-dark-200">
      <NuxtPage />
    </div>
  </div>
</template>
